import React from 'react'
import { Popup, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import './ActionButton.css';

const FloatingActionButton = (props) => {
    return (
        <div >
            <Popup
            content={props.text}
            trigger={
            <Link to={props.to} className="ActionButton">
            <Button
                icon={props.icon}
                circular
                size="massive"
                color={props.color}
            />
            </Link>
            }
            />
        </div>
    )
}

export default FloatingActionButton;